var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAfrica(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 64.91 72.71",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "inherit",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3,
    d: "M8.38 33.27a6.9 6.9 0 0 0 3 1.11 55 55 0 0 0 8.24-.33c3.19-.42 4.41.56 4.73 3.62a10.5 10.5 0 0 0 1.95 4.51c1.65 2.43 2.44 4.82.91 7.55a5.78 5.78 0 0 0-.21 5.35c1 2.49 1.87 5.08 2.93 7.56 1.35 3.15 2.08 6.74 5.49 8.57h2.79c3.68-2.27 7.54-4.37 8.28-9.29 0-.38.63-.65.87-1 .69-1.09 1.32-2.21 2-3.33a21 21 0 0 1 2.43-4c2.13-2.22 3-4.43 1.71-7.14-1.39-2.87-.79-4.93 1.4-7a58.5 58.5 0 0 0 6.41-7 5 5 0 0 0 .62-4c-.28-.84-2-1.61-3.15-1.64a6.31 6.31 0 0 1-6-3.68c-1.39-2.76-2.69-5.58-3.85-8.45-1.44-3.6-3.44-6.4-7.69-6.8a10 10 0 0 1-2.41-.83c-2.9-1.07-4-.74-5.87 1.71-.55-.26-1.13-.48-1.66-.79-1.58-.94-3.46-1.4-3.49-4 0-.82-2.08-2.33-3.19-2.31A84 84 0 0 0 14 2.67a3.87 3.87 0 0 0-2.14 1.23C9.27 7 6.41 9.93 4.4 13.36c-1.55 2.64-2.06 5.9-2.85 8.93 0 0-.52 1.78 1.74 5.35a24 24 0 0 0 5.09 5.63m55.03 22.65C63 57.28 62.49 58.63 62 60a14 14 0 0 1-.66 1.84A1.85 1.85 0 0 1 59.2 63a2 2 0 0 1-1.71-2 16 16 0 0 1 .26-1.92c.13-2.07.75-3.81 2.79-4.8.3-.14.35-.75.61-1.07s.69-.75.91-.69.64.55.85.92a7.7 7.7 0 0 1 .5 1.29z",
    "data-name": "Layer 43"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAfrica);
export default __webpack_public_path__ + "static/media/africa.830fab2fc7782d92139c671a2a7054b3.svg";
export { ForwardRef as ReactComponent };